var map = {
	"./cargos-partidarios.js": "vwfI"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Hf7m";


//////////////////
// WEBPACK FOOTER
// ./src/router/routes nonrecursive .*\.js$
// module id = Hf7m
// module chunks = 13